module.exports = __webpack_public_path__ + "img/phone2.86ce8614.png";